"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSConnector = exports.WSModels = exports.WSConnectorTypes = exports.WSRequest = exports.WSChannel = void 0;
const ws_1 = __importDefault(require("ws"));
const channel_1 = require("./channel");
const WSConnectorTypes = __importStar(require("./types"));
exports.WSConnectorTypes = WSConnectorTypes;
const WSModels = __importStar(require("./models"));
exports.WSModels = WSModels;
// delay between pings.
// see WSConnector.intervalHeartbeat
const DEFAULT_INTERVAL_HEARTBEAT = 3000;
// 2x DEFAULT_INTERVAL_HEARTBEAT to allow for missing
// one heartbeat without triggering disconnect.
// see WSConnector.timeoutHeartbeat
const DEFAULT_TIMEOUT_HEARTBEAT = 6100;
// see WSConnector.timeoutConnect
const DEFAULT_TIMEOUT_CONNECT = 2000;
exports.WSChannel = WSConnectorTypes.WSChannel, exports.WSRequest = WSConnectorTypes.WSRequest;
/**
 * WSConnector is a wrapper class to manage websocket connections with the server. It makes use of
 * WebSocket instances to connect to the server.
 *
 * Provides a synchronised way of executing requests on websocket @see {WSConnector.request}.
 *
 * Multiple subscriptions to the same channel is not supported at the moment, but would be trival
 * to implement.
 *
 * @example
 * (async () => {
 *   const wsConnector = new WSConnector({
 *     endpoint: WS_ENDPOINT,
 *   });
 *
 *   // run connect before executing any request/subscription
 *   await wsConnector.connect();
 *
 *   // request for data
 *   const result: WSResult<RecentTradesBody> = await wsConnector.request<RecentTradesBody>("get_recent_trades", {
 *      market: "swth_eth",
 *   });
 *
 *   // subscribe to new channel
 *   await wsConnector.subscribe({ channel: WSChannel.market_stats }, (result: WSResult<MarketStats>) => {
 *     console.log("received market stats", result);
 *   });
 *
 *   // unsubscribe
 *   await wsConnector.unsubscribe({ channel: WSChannel.market_stats });
 *
 *   // clean up
 *   await wsConnector.disconnect();
 * })();
 */
class WSConnector {
    /**
     * Initialises an instance of WSConnector with the specified options
     * @param {WSConnectorOptions} options - options to configure the WSConnector instance
     */
    constructor(options) {
        // websocket instance
        this.websocket = null;
        // used to tracking websocket messages, increment by 1 every request
        this.requestIdCounter = 0;
        // true if connection initiated, even if connection is not established
        // will cause reconnect attempts if true.
        this.shouldConnect = false;
        // true only if connection is established and ready to use
        this.connected = false;
        // promise abstraction handler for WSConnector.connect
        this.connectPromiseHandler = null;
        // promise abstraction handlers store for WSConnector.request
        this.requestHandlers = {};
        // channel subscription handlers
        this.channelHandlers = {};
        // used for track ws message sequence, for some cases a out of sequence
        // message is invalid and request have to be resent.
        this.sequenceNumberCache = {};
        const { endpoint, debugMode = false, timeoutConnect = DEFAULT_TIMEOUT_CONNECT, intervalHeartbeat = DEFAULT_INTERVAL_HEARTBEAT, timeoutHeartbeat = DEFAULT_TIMEOUT_HEARTBEAT, disableHeartbeat = false, onStatusChange, } = options;
        this.endpoint = endpoint;
        this.debugMode = debugMode;
        this.timeoutConnect = timeoutConnect;
        this.intervalHeartbeat = intervalHeartbeat;
        this.timeoutHeartbeat = timeoutHeartbeat;
        this.disableHeartbeat = disableHeartbeat;
        this.statusChangeListener = onStatusChange;
    }
    /**
     * Starts a connection to the server via a WebSocket instance
     * rejects the promise if connection cannot be established within WSConnector.timeoutConnect
     * milliseconds.
     *
     * @see WSConnector documentation for usage example
     */
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.shouldConnect) {
                // resolve promise immediately if already connecting
                return Promise.resolve();
            }
            this.shouldConnect = true;
            this.connectWebSocket();
            return new Promise((resolve, reject) => {
                this.connectPromiseHandler = { resolve, reject };
            });
        });
    }
    /**
     * Disconnects the WebSocket connection with endpoint, releases resources and reverse states.
     * It is safe to call WSConnector.connect() again once WSConnector.disconnect() is called.
     *
     * @see WSConnector documentation for usage example
     */
    disconnect() {
        this.shouldConnect = false;
        this.disconnectWebsocket();
    }
    /**
     * Subscribes to the channels specified with the websocket. Sends a subscription data frame with
     * channel ID to WebSocket server.
     * @param {WSConnectorTypes.WsSubscriptionParams | WSConnectorTypes.WsSubscriptionParams[]} params a list of parameters specifying the channels to connect to
     * @param {WSSubscriber} handler an event handler that subscribes to the websocket channels
     *
     * @see WSConnector documentation for usage example
     */
    subscribe(params, handler) {
        const channels = [];
        if (!Array.isArray(params)) {
            params = [params]; // eslint-disable-line no-param-reassign
        }
        for (const param of params) {
            const channelId = (0, channel_1.generateChannelId)(param);
            const shouldSubscribe = this.channelHandlers[channelId] === undefined;
            this.channelHandlers[channelId] = handler;
            if (shouldSubscribe) {
                channels.push(channelId);
            }
        }
        this.send('subscribe', { channels });
    }
    /**
     * Unsubscribes to the websocket channels indicated in the params, by broadcasting an unsubscribe
     * message to these channels.
     * @param {WSConnectorTypes.WsSubscriptionParams | WSConnectorTypes.WsSubscriptionParams[]} params - channel(s) to unsubcribe to
     *
     * @see WSConnector documentation for usage example
     */
    unsubscribe(params) {
        if (!Array.isArray(params)) {
            params = [params]; // eslint-disable-line no-param-reassign
        }
        const channelIds = [];
        for (const param of params) {
            const channelId = (0, channel_1.generateChannelId)(param);
            delete this.channelHandlers[channelId];
        }
        this.send('unsubscribe', {
            channels: channelIds,
        });
    }
    /**
     * Sends a message to the websocket channels.
     * @param {string} method - the type of message to send to the websocket channels. Available
     * options: subscribe, unsubscribe, get_recent_trades, get_candlesticks, get_open_orders,
     * get_account_trades, get_market_stats, get_leverages, get_open_positions, get_closed_positions
     * @param {any} params - An object containing parameters based on the specified method
     */
    send(method, params) {
        this.sendMessage(JSON.stringify({
            id: `g${++this.requestIdCounter}`,
            method,
            params,
        }));
    }
    /**
     * Requests data from the server endpoint
     * @param {string} method - the type of message to send to the websocket channels. Available
     * options: subscribe, unsubscribe, get_recent_trades, get_candlesticks, get_open_orders,
     * get_account_trades, get_market_stats, get_leverages, get_open_positions, get_closed_positions
     * @param {any} params - parameters based on the specified method
     *
     * @returns {Promise<WSResult<T>>} - a Promise resolving to the response from the endpoint
     *
     * @see WSConnector documentation for usage example
     */
    request(method, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestId = `r${++this.requestIdCounter}`;
            this.sendMessage(JSON.stringify({
                id: requestId,
                method,
                params,
            }));
            return new Promise((resolve, reject) => {
                this.requestHandlers[requestId] = { requestId, resolve, reject };
            });
        });
    }
    /**
     * Sends a message to the web socket
     * @param {string | Buffer} data - the message sent to the web socket
     */
    sendMessage(data) {
        const socket = this.getSocket();
        this.debugLog('WSConnector.sendMessage', data);
        socket === null || socket === void 0 ? void 0 : socket.send(data);
    }
    /**
     * An event handler that is called when a connection is started with the WebSocket instance.
     * @param {Event} ev - the event that is called with
     */
    onOpen(ev) {
        var _a;
        this.debugLog('WSConnector.onOpen', ev);
        // clear timeout for killing connect attempts
        clearTimeout(this.timeoutConnect);
        this.connected = true;
        (_a = this.connectPromiseHandler) === null || _a === void 0 ? void 0 : _a.resolve();
        this.connectPromiseHandler = null;
        this.updateConnectStatus();
        this.startHeartbeat();
    }
    /**
     * An event handler that is called when a MessageEvent is emitted from the server
     * @param {MessageEvent} ev - the MessageEvent that is emitted from the server
     */
    onMessage(ev) {
        var _a;
        this.debugLog('WSConnector.onMessage', ev);
        if (ev.data === 'pong') {
            this.restartHeartbeatTimeout();
            return;
        }
        const message = this.parseWsMessage(ev);
        if (!message.requestId && message.channel) {
            const channelHandler = this.channelHandlers[message.channel];
            if (!channelHandler) {
                this.debugLog(`handler not found for channel: ${message.channel}`);
                try {
                    const params = (0, channel_1.parseChannelId)(message.channel);
                    this.unsubscribe({ channel: params.channel });
                }
                catch (error) {
                    // ignore error
                }
                return;
            }
            channelHandler(message.result);
            return;
        }
        if (!((_a = message.requestId) === null || _a === void 0 ? void 0 : _a.startsWith('r'))) {
            return;
        }
        const handler = this.requestHandlers[message.requestId];
        if (!handler) {
            this.debugLog(`handler not found for request: ${message.requestId}`);
            return;
        }
        if (message.error) {
            handler.reject(message.error);
        }
        else {
            handler.resolve(message.result);
        }
        delete this.requestHandlers[message.requestId];
    }
    /**
     * An event listener that is called when an error occurs on the WebSocket connection
     * @param {Event} ev - the error event occurring on the WebSocket connection
     */
    onError(ev) {
        this.debugLog('WSConnector.onError', ev);
        const handlers = Object.values(this.requestHandlers);
        console.error(ev);
        const error = new Error('WebSocket error occurred');
        for (const handler of handlers) {
            handler.reject(error);
            if (handler.requestId) {
                delete this.requestHandlers[handler.requestId];
            }
        }
    }
    /**
     * An event handler that is triggered when the WebSocket connection is closed.
     * @param {Event} ev - the event called with this event handler.
     */
    onClose(ev) {
        this.debugLog('WSConnector.onClose', ev);
        this.disconnectWebsocket();
    }
    /**
     * An accessor to the WebSocket instance in this WSConnector instance
     */
    getSocket() {
        if (!this.connected) {
            throw new Error('WebSocket not connected');
        }
        return this.websocket;
    }
    /**
     * Updates the connection status of the WebSocket instance
     */
    updateConnectStatus() {
        var _a;
        try {
            (_a = this.statusChangeListener) === null || _a === void 0 ? void 0 : _a.call(this, this.connected);
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * Sends ping messages to the websocket to indicate to the server that the WebSocket connection with the server is still alive.
     */
    sendHeartbeat() {
        var _a;
        (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.send('ping');
    }
    /**
     * Resets the heartbeat timeout. (timeout: after a specified amount of time, if there are no heartbeats detected from the server, the connection with the server is considered to be lost and the WebSocket connection will be closed)
     */
    restartHeartbeatTimeout() {
        clearTimeout(this.heartbeatTimeout);
        if (this.disableHeartbeat || this.timeoutHeartbeat <= 0) {
            // configured to disable heartbeat checks
            return;
        }
        this.heartbeatTimeout = setTimeout(this.onHeartbeatTimeout.bind(this), this.timeoutHeartbeat);
    }
    /**
     * Disconnects the websocket connection when there is no heartbeat detected for more than the time specified in {@link WSConnector#timeoutHeartbeat}
     */
    onHeartbeatTimeout() {
        this.debugLog('heartbeat timed out');
        console.warn('ws heartbeat missed, killing zombie connection');
        this.disconnect();
    }
    /**
     * Starts sending heartbeats to the server in regular intervals
     */
    startHeartbeat() {
        // call receive heartbeat to start timeout
        this.restartHeartbeatTimeout();
        if (this.disableHeartbeat || this.intervalHeartbeat <= 0) {
            // configured to disable heartbeat checks
            return;
        }
        this.heartbeatInterval = setInterval(this.sendHeartbeat.bind(this), this.intervalHeartbeat);
    }
    /**
     * Parses messages sent from the server via the WebSocket connection
     * @param {MessageEvent} ev - the MessageEvent emitted from the server
     * @returns {WSMessage<T>} - the parsed message
     */
    parseWsMessage(ev) {
        try {
            const _a = JSON.parse(ev.data), { id, sequence_number: sequenceNumber, error, channel } = _a, rest = __rest(_a, ["id", "sequence_number", "error", "channel"]);
            const outOfSequence = sequenceNumber < this.sequenceNumberCache[channel];
            if (!outOfSequence) {
                this.sequenceNumberCache[channel] = sequenceNumber;
            }
            return {
                requestId: id,
                channel,
                sequenceNumber,
                error: error,
                result: {
                    requestId: id,
                    channel,
                    timestamp: new Date(),
                    outOfSequence,
                    data: rest,
                },
            };
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    }
    /**
     * Rejects the WebSocket connection attempt when an error is encountered
     * @param {Error} error - the error causing the failure to connect with the websocket
     */
    rejectConnect(error) {
        var _a;
        clearTimeout(this.initFailureTimeout);
        (_a = this.connectPromiseHandler) === null || _a === void 0 ? void 0 : _a.reject(error);
        this.connectPromiseHandler = null;
    }
    /**
     * Disconnects the connection with the websocket
     */
    disconnectWebsocket() {
        var _a;
        try {
            (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.close();
        }
        catch (e) {
            // ignore error on disconnect
        }
        finally {
            clearInterval(this.heartbeatInterval);
            clearTimeout(this.heartbeatTimeout);
            this.sequenceNumberCache = {};
            this.websocket = null;
            if (this.connected) {
                this.connected = false;
                this.updateConnectStatus();
            }
        }
    }
    /**
     * Initialises a new WebSocket instance with the specified endpoint.
     */
    connectWebSocket() {
        this.disconnect();
        try {
            if (typeof WebSocket !== 'undefined') {
                // this works on browsers js vm
                const websocket = new WebSocket(this.endpoint);
                websocket.onopen = this.onOpen.bind(this);
                websocket.onclose = this.onClose.bind(this);
                websocket.onerror = this.onError.bind(this);
                websocket.onmessage = this.onMessage.bind(this);
                this.websocket = websocket;
            }
            else {
                // and this works on nodejs vm
                const websocket = new ws_1.default(this.endpoint);
                websocket.on('open', this.onOpen.bind(this));
                websocket.on('close', this.onClose.bind(this));
                websocket.on('error', this.onError.bind(this));
                websocket.on('message', (data) => this.onMessage({ data }));
                this.websocket = websocket;
            }
            this.requestHandlers = {};
            // set timeout to kill websocket instantiation attempt
            // because error for constructor cannot be caught
            // i.e. new WebSocket(…)
            // https://stackoverflow.com/questions/22919638
            this.initFailureTimeout = setTimeout(() => {
                this.rejectConnect(new Error('websocket connect time out'));
            }, this.timeoutConnect);
        }
        catch (error) {
            console.error(error);
            if (error instanceof Error) {
                this.rejectConnect(error);
            }
        }
    }
    /**
     * A helper message to log methods when they are called
     * WSConnector#debugMode must be set to true to turn on logging.
     * @param {any[]} args - items to be logged
     */
    debugLog(...args) {
        if (!this.debugMode)
            return;
        console.log(...args);
    }
}
exports.WSConnector = WSConnector;
WSConnector.generateChannelId = channel_1.generateChannelId;
WSConnector.parseChannelId = channel_1.parseChannelId;
